export default __webpack_public_path__ + "static/media/PublicView.93c96a11.svg";